import styles from './organisation-area-groups-overlay.module.scss';

import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useDialogs } from '@work4all/components';
import { NavigationOverlay } from '@work4all/components/lib/navigation/navigation-overlay';

import { MaskContextProvider } from '../../../containers/mask-overlays/mask-overlay/hooks/mask-context';
import { useOrganisationAreaContext } from '../hooks';

import { OrganisationAreaCategoriesPage } from './organisation-area-categories-page';

export const OrganisationAreaCategoriesOverlay = () => {
  const dialogs = useDialogs();

  const { isCategoriesEditOverlayOpen, setCategoriesEditOverlayOpen } =
    useOrganisationAreaContext();

  const { t } = useTranslation();

  const [isDirty, setIsDirty] = useState(false);

  if (!isCategoriesEditOverlayOpen) return null;

  const handleClose = async () => {
    if (isDirty) {
      const confirmed = await dialogs.confirm({
        title: t('ALERTS.CONFIRM'),
        description: t('ALERTS.ABORT_MESSAGE'),
        confirmLabel: t('MASK.GROUP_MANAGEMENT.DIALOG.ABORT'),
        cancelLabel: t('ALERTS.NO'),
      });

      if (!confirmed) {
        return;
      }
    }
    setIsDirty(false);
    setCategoriesEditOverlayOpen(false);
  };

  return (
    <MaskContextProvider
      value={{
        entity: undefined,
        isCreateMode: false,
        isEditMode: false,
        mode: 'edit',
        params: null,
        wip: false,
      }}
    >
      <NavigationOverlay
        open={isCategoriesEditOverlayOpen}
        initialView={{
          title: t('COMMON.FILTERS'),
          view: <OrganisationAreaCategoriesPage setIsDirty={setIsDirty} />,
        }}
        close={handleClose}
        classes={{ wrapper: styles.wrapper }}
      />
    </MaskContextProvider>
  );
};
